import { Component, ElementRef, HostBinding, NgZone, OnInit, ViewChild, inject } from '@angular/core';
import { OfferSetTemplateBase } from '../offer-set-template-base.component';

declare let Hls: any; // TODO: fix this after hls.js can support SSR

@Component({
  selector: 'app-floating-offer-set-template',
  templateUrl: './floating-offer-set-template.component.html',
  styleUrls: ['./floating-offer-set-template.component.scss']
})
export class FloatingOfferSetTemplateComponent extends OfferSetTemplateBase implements OnInit {
  private ngZone = inject(NgZone);

  @ViewChild('video') video : ElementRef;

  initialized = false;

  @HostBinding('class.first-step')
  get isFirstStep() {
    return this.step === 'pricing';
  }

  afterInitialized() {
    console.log(`afterInitialized`);
    this.initialized = true;
    if (this.vod && this.offerSet) {
      this.initVideo();
    } else {
      console.log(`no vod after init`);
    }
  }

  ngAfterViewInit() {
    console.log(`afterViewInit`);
    if (this.vod && this.offerSet)
      this.initVideo();
  }

  videoInitialized = false;

  protected onOfferSetUpdated(): void {
    if (!this.initialized)
      return;
    this.videoInitialized = false;
    this.initVideo();
  }

  private initVideo() {
    console.log(`initVideo()`);
    if (!this.hasFeaturedMedia) {
      console.log(`Offer set has no featured media`);
      return;
    }
    if (this.videoInitialized)
      return;

    this.videoInitialized = true;
    let preferNativeHls = false;
      
    let userAgent = navigator.userAgent;
    if (userAgent.includes('Safari/') && !userAgent.includes('Chrome/')) {
        console.log(`HlsPlayback: Safari detected: preferring native HLS`);
        preferNativeHls = true;
    }

    console.log(`Playing VOD:`, this.vod);
    let video : HTMLVideoElement = this.video.nativeElement;
    let useHlsJs = () => {
      console.log(`Using hls.js...`);
        this.ngZone.runOutsideAngular(() => {
            var hls = new Hls();
            hls.loadSource(this.vod.asset.url);
            hls.attachMedia(video);
            hls.on(Hls.Events.MANIFEST_PARSED, function () {
                // if we want autoplay:
                //video.play();
            });
        });
    }

    let useNativeHls = () => {
      console.log(`Using native HLS...`);
        video.src = this.vod.asset.url;
        video.addEventListener('loadedmetadata', function () {
            // if we want autoplay
            // video.play();
        });
    }

    let cannotPlay = false;
    if (preferNativeHls) {
        if (video.canPlayType('application/vnd.apple.mpegurl'))
            useNativeHls();
        else if (Hls.isSupported())
            useHlsJs();
        else
            cannotPlay = true;
    } else {
        if (Hls.isSupported())
            useHlsJs();
        else if (video.canPlayType('application/vnd.apple.mpegurl'))
            useNativeHls();
        else
            cannotPlay = true;
    }

    if (cannotPlay)
      console.error(`No HLS support available!`);
  }
}
